import {
    useForm,
    // Controller,
    type SubmitHandler } from "react-hook-form"
// import Select from '@mui/material/Select'
// import InputLabel from '@mui/material/InputLabel'
// import MenuItem from '@mui/material/MenuItem'
// import FormControl from '@mui/material/FormControl'

import useFormLocalStorage from "@/hooks/use-form-local-storage"
import { APP_VERSION } from "@/constants/general"
import Form from "@/components/forms/reusables/form"
import useFormStates from "@/hooks/use-form-states"
import type {
    // CollectionPeriod,
    YearlyFeeCollection,
    YearlyFeeCollectionFormInput,
} from "@/types"
import {
    useCreateYearlyFeeCollection,
    useUpdateYearlyFeeCollection,
} from "@/hooks/api/use-yearly-fee-collection"
import RHFNumberTextfield from "@/components/form-fields/rhf-number-textfield"
import RHFTextfield from "@/components/form-fields/rhf-textfield"
import { convertFromCents } from "@/helpers"

const YearlyFeeCollectionForm = ({
    yearlyFeeCollection,
    year,
    closeCallback,
} : {
    yearlyFeeCollection?: YearlyFeeCollection,
    year: number,
    closeCallback?: () => void,
}) => {

    const formDataId = `yearlyFeeCollectionForm-${yearlyFeeCollection?.id}-v${APP_VERSION}`

    const initialValues = {
        year: yearlyFeeCollection ? yearlyFeeCollection.year : year,
        discounts_from_year: yearlyFeeCollection ? yearlyFeeCollection.discounts_from_year : year-1,
        iban: yearlyFeeCollection ? yearlyFeeCollection.iban : '',
        fee_amount: yearlyFeeCollection ? convertFromCents(yearlyFeeCollection.fee_amount_cents) : '',
        // collection_period: yearlyFeeCollection ? yearlyFeeCollection.collection_period : CollectionPeriod.yearly,
        max_discount: yearlyFeeCollection ?
            yearlyFeeCollection.max_discount_cents != null ? convertFromCents(yearlyFeeCollection.max_discount_cents) : ''
            : '',
    }
    
    const {
        control,
        handleSubmit,
        formState: { isDirty },
        reset,
    } = useForm({
        defaultValues: { ...initialValues },
    })

    const [isLoadedFromLocalStorage, handleFormReset] = useFormLocalStorage({
        control,
        formDataId,
        reset,
        initialValues
    })

    const {
        resetWithVersion,
        requestInProgress,
        setRequestInProgress,
        setError,
        error,
    } = useFormStates(handleFormReset)

    const mutationCreate = useCreateYearlyFeeCollection({
        setRequestInProgress,
        formDataId,
        onSuccessCallback: closeCallback,
        onErrorCallback(errorMessage) {
            setError(errorMessage)
        }
    })

    const mutationUpdate = useUpdateYearlyFeeCollection(
        yearlyFeeCollection?.id,
        {
            setRequestInProgress,
            formDataId,
            onSuccessCallback: closeCallback,
            onErrorCallback(errorMessage) {
                setError(errorMessage)
            }
        },
    )

    const onSubmit: SubmitHandler<YearlyFeeCollectionFormInput> = data => {
        setRequestInProgress(true)
        if (yearlyFeeCollection?.id) {
            mutationUpdate.mutate(data)
        } else {
            mutationCreate.mutate(data)
        }
    }

    return (
        <Form
            onSubmit={handleSubmit(onSubmit)}
            heading={yearlyFeeCollection ? 'Upravit podklady pro výběr' : 'Vytvořit podklady'}
            closeCallback={closeCallback}
            isLoadedFromLocalStorage={isLoadedFromLocalStorage}
            isDirty={isDirty}
            resetWithVersion={resetWithVersion}
            requestInProgress={requestInProgress}
            buttonText={yearlyFeeCollection ? 'Upravit' : 'Vytvořit podklady'}
            error={error}
            setError={setError}
        >
            <RHFTextfield
                name="year"
                control={control}
                label="Rok"
                disabled
            />
            <RHFTextfield
                name="discounts_from_year"
                control={control}
                label="Sleva z motivačního modelu roku"
                disabled
            />
            <RHFNumberTextfield
                name="fee_amount"
                control={control}
                label="Základní poplatek bez slev"
                endAdornment="Kč"
                decimalScale={2}
                thousandSeparator
                disallowNegative
                required
            />
            <RHFNumberTextfield
                name="max_discount"
                control={control}
                label="Maximální sleva"
                endAdornment="Kč"
                decimalScale={2}
                thousandSeparator
                disallowNegative
            />
            {/* <FormControl fullWidth>
                <InputLabel id="year-select-label">Perioda výběru</InputLabel>
                <Controller
                    name="collection_period"
                    control={control}
                    render={({ field }) => (
                        <Select {...field} label="Perioda výběru">
                            <MenuItem value={CollectionPeriod.yearly}>Roční</MenuItem>
                            <MenuItem value={CollectionPeriod.semiannual}>Půlroční</MenuItem>
                            <MenuItem value={CollectionPeriod.monthly}>Měsíční</MenuItem>
                        </Select>
                    )}
                />
            </FormControl> */}
            <RHFTextfield
                name="iban"
                control={control}
                label="Číslo účtu pro výběr poplatku ve formátu IBAN"
                required
            />
        </Form>
    )
}

export default YearlyFeeCollectionForm
